import AppDBStorage from '@Services/AppDBStorage';

class StructureEditorOptionsStorage extends AppDBStorage {
  constructor() {
    super('StructureEditorOptions_');
  }
}

export default new StructureEditorOptionsStorage();
